import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { toast } from "sonner";
import { CreditCard, Loader2, Lock } from "lucide-react";

/** Carte « Payer par carte bancaire (Stripe) » du checkout public : abonnement récurrent via Stripe Checkout. */
export function StripeCheckoutCard({ inscriptionId, disabled, mode }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/stripe/checkout/${inscriptionId}`, { origin_url: window.location.origin });
      toast.success("Redirection vers le paiement sécurisé Stripe…");
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Stripe indisponible"); setBusy(false); }
  };
  return (
    <div className="bg-white border border-[#DEE2E6] p-6 lg:p-8 flex flex-col" data-testid="pay-method-stripe">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 flex items-center justify-center bg-[#635BFF] rounded text-white"><CreditCard className="h-5 w-5" /></div>
        <div>
          <div className="font-display font-bold text-xl">Carte bancaire</div>
          <div className="text-xs text-[#868E96]">via Stripe · Abonnement récurrent · Renouvellement automatique{mode === "test" ? " · mode test" : ""}</div>
        </div>
      </div>
      <p className="text-sm text-[#495057] mb-6 flex-1">
        Visa, Mastercard, American Express, Apple Pay ou Google Pay. Vous êtes redirigé vers la page de paiement sécurisée Stripe ; vos identifiants PAG vous sont envoyés dès la confirmation.
      </p>
      <button type="button" onClick={go} disabled={disabled || busy} data-testid="pay-stripe-btn"
        className="h-12 w-full inline-flex items-center justify-center gap-2 bg-[#635BFF] hover:bg-[#4f46e5] disabled:opacity-50 text-white font-semibold text-sm transition-colors">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Payer par carte
      </button>
    </div>
  );
}
